import { useIntl } from '../../hooks/useIntl';
import { container } from './style.css';

const intlSpec = {
  keys: {
    label: 'general.game_info_version',
  },
};

const GameVersion = () => {
  const { label } = useIntl(intlSpec);

  return (
    <div className={container}>
      {label}
    </div>
  );
};

export default GameVersion;
